<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <button mat-raised-button color="primary" *LOSxHasPermission="'UPDATE_REPORT'" (click)="onEdit()">
    <fa-icon icon="edit" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Edit' | translate }}
  </button>
</div>

<div class="container m-b-20">
  <mat-card>
    <mat-card-header class="layout-column">
      <mat-card-title>{{ 'labels.buttons.Survey' | translate }}</mat-card-title>
      <mat-divider [inset]="true"></mat-divider>
    </mat-card-header>
    <mat-card-content>
      <div class="layout-row-wrap">
        <div class="flex-40 flex-lt-md-50 header">
          <b>{{ 'labels.inputs.Key' | translate }}:</b>
        </div>

        <div class="flex-60 flex-lt-md-50">
          {{ surveyData.key }}
        </div>

        <div class="flex-40 flex-lt-md-50 header">
          <b>{{ 'labels.inputs.Name' | translate }}:</b>
        </div>

        <div class="flex-60 flex-lt-md-50">
          {{ surveyData.name }}
        </div>

        <div class="flex-40 flex-lt-md-50 header">
          <b>{{ 'labels.inputs.Country Code' | translate }}:</b>
        </div>

        <div class="flex-60 flex-lt-md-50">
          {{ surveyData.countryCode }}
        </div>

        <div class="flex-40 flex-lt-md-50 header">
          <b>{{ 'labels.inputs.Description' | translate }}:</b>
        </div>

        <div class="flex-60 flex-lt-md-50">
          {{ surveyData.description }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div class="container m-b-20">
  <mat-card class="questions">
    <mat-card-header class="layout-column">
      <mat-card-title>{{ 'labels.inputs.Questions' | translate }}</mat-card-title>
      <mat-divider [inset]="true"></mat-divider>
    </mat-card-header>
    <mat-card-content>
      @for (questionData of surveyData.questionDatas; track questionData; let i = $index) {
        <div class="survey-questions">
          <mat-card>
            <mat-card-content>
              <div>{{ 'labels.heading.Question' | translate }}: {{ i + 1 }}</div>
              <div class="layout-row" id="key-text">
                <div class="flex-25 header">
                  <b>{{ 'labels.inputs.Key' | translate }}:</b>
                </div>
                <div class="flex-40 flex-50-lt-md">
                  {{ questionData.key }}
                </div>
                <div class="flex-40 flex-lt-md-50 header">
                  <b>{{ 'labels.inputs.Text' | translate }}:</b>
                </div>
                <div class="flex-40 flex-50-lt-md">
                  {{ questionData.text }}
                </div>
              </div>
              <div class="layout-row" id="description">
                <div class="flex-20 flex-50-lt-md header">
                  <b>{{ 'labels.inputs.Description' | translate }}:</b>
                </div>
                <div class="flex-40 flex-50-lt-md">
                  {{ questionData.description }}
                </div>
              </div>
              <div class="layout-column" id="questionaire">
                <div>
                  <b>{{ 'labels.inputs.Option' | translate }}: </b>
                </div>
                <table id="response">
                  <tr>
                    @for (column of displayedColumns; track column) {
                      <th>{{ column | titlecase }}</th>
                    }
                  </tr>
                  @for (row of questionData.responseDatas; track row) {
                    <tr>
                      @for (column of displayedColumns; track column) {
                        <td>
                          {{ row[column] }}
                        </td>
                      }
                    </tr>
                  }
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
